import { Controller, Get, Param, UseGuards } from '@nestjs/common';
import { AuthGuard } from '@nestjs/passport';
import { ApiBearerAuth, ApiOperation, ApiTags } from '@nestjs/swagger';
import type { LoginUserInfo } from '../../auth/dto/login.dto';
import { RequireModule, RequirePermission } from '../../auth/decorators';
import { ModuleGuard } from '../../auth/guards/module.guard';
import { PermissionGuard } from '../../auth/guards/permission.guard';
import { GetUser } from '../../auth/get-user.decorator';
import { ClientesCarteraService } from './clientes-cartera.service';

@ApiTags('Cartera Inteligente — Clientes')
@ApiBearerAuth()
@UseGuards(AuthGuard('jwt'), ModuleGuard, PermissionGuard)
@RequireModule('COBRANZAS')
@Controller({ path: 'cartera/clientes', version: '1' })
export class ClientesCarteraController {
  constructor(private readonly service: ClientesCarteraService) {}

  @Get(':id')
  @RequirePermission('COBRANZAS', 'COB_CART_VER')
  @ApiOperation({
    summary: 'Detalle de cliente con cuentas pendientes y timeline de gestiones',
  })
  detalle(@Param('id') id: string, @GetUser() user: LoginUserInfo) {
    return this.service.detalle(user.empresa_id, id);
  }
}
